/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data-item__content-wrapper[_ngcontent-%COMP%]{display:flex;margin:auto}"];
export { styles as styles };
